export {default} from './chatChannelModel';
export * from './chatChannelModel';
export * from './message';
export * from './types';



// WEBPACK FOOTER //
// ./src/models/chatChannelModel/index.ts